export default {
  run: '波次号',
  carton: '箱号',
  plant: '仓库号',
  product: '产品代号',
  size: '产品尺码',
  salesOrderType: '订单类型',
  waveRunDate: '波次时间',
  qty: '数量',
  rfid: 'RFID',
  nfc: 'NFC',
  normal: '普通货物',
  status: '绑定状态',
  type: '类型',
  illegalUPC: '非法的UPC',
  paramEmpty: '参数不能为空',
  scan: '请扫描',
  errorcode_1112: ': 文件名必须符合规则',
  errorcode_1113: ': 波次运行批次号已存在于数据库中',
  errorcode_1114: ': 波次运行文件重复',
  errorcode_1111: ': 源文件为空',
  errorcode_500: ': 系统错误',
  errorcode_1104: '波次运行源文件配置不存在',
  errorcode_1200: 'SML共享文件夹配置不存在',
  errorcode_1201: '1027波形运行初始化目录不存在',
  errorcode_1202: '复制SML 1027波形运行文件发生错误',
  errorcode_604: '该箱号已被取消。',
  tagType: '标签类型',
  updatedTime: '更新时间 ',
  productQuantity: '产品数量',
  noTagTypeProduct: '非NFC产品',
  manualUpdateWaveRun: '手动更新Wave Run',
  errorcode_1501: '文件处理失败，请至failure文件夹中查看。'
}
